import { getSortObjectFromString } from 'utils/url/getSortObjectFromString';
const sortFields = [
    'created_at',
    'last_message_created_at',
    'updated_at',
];
/** Converts a sort object to a URL-friendly string. */
export function convertSortObjectToString(sort) {
    return sort ? `${sort.field}:${sort.order}` : '';
}
/** Converts a URL-friendly string to a sort object. */
export function convertSortStringToObject(sort) {
    if (!sort)
        return undefined;
    const sortObject = getSortObjectFromString(sort, sortFields);
    if (sortObject && sortObject.direction) {
        return { field: sortObject.key, order: sortObject.direction };
    }
}
